/**
 * FE INVOICES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getFeInvoices,
    getFeInvoice,
    printFeInvoice,
    createFeInvoices,
    updateFeInvoices,
    deleteFeInvoices,
} from "Modules/sales/fe_invoices/config/api.fe_invoices";

const state = {
    page: {},
    form: {},
    fe_invoices: [],
    selectedFeInvoice: {
        invoice_id: null,
        company_id: "",
        fe_invoice_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        fe_invoice_details: [],
    },
    fe_invoices_filter: {
        search: "",
        status_id: "",
        page_size: 2,
        page_num: 1,
    },
    rules_fe_invoices: {
        invoice_id: {
            name: "invoice_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        rfq_id: {
            name: "rfq_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quote_id: {
            name: "quote_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        purchase_order_id: {
            name: "purchase_order_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        order_id: {
            name: "order_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_location_label: {
            name: "bill_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_location_label: {
            name: "ship_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        invoice_date: {
            name: "invoice_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        due_date: {
            name: "due_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        work_order_no: {
            name: "work_order_no",
            rules: "trim|max_length[20]",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "19",
            min_len: "",
            default_value: "",
        },
        subtotal: {
            name: "subtotal",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount: {
            name: "discount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount_type: {
            name: "discount_type",
            rules: "trim|max_length[1]",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        total_amount: {
            name: "total_amount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customer_po: {
            name: "customer_po",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        freight: {
            name: "freight",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customs: {
            name: "customs",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        expedite_fee: {
            name: "expedite_fee",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        handling_charge: {
            name: "handling_charge",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        project_id: {
            name: "project_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        fe_invoice_details: {
            part_id: {
                name: "part_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            sales_unit: {
                name: "sales_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            cost_price: {
                name: "cost_price",
                rules: "trim|max_length[13]|decimal",
                max_len: "12",
                min_len: "",
                default_value: "",
            },
            unit_price: {
                name: "unit_price",
                rules: "trim|max_length[13]|decimal|required",
                max_len: "12",
                min_len: "",
                default_value: "0.000",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            lead_time: {
                name: "lead_time",
                rules: "trim|max_length[3]|integer",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
            line_discount_amount: {
                name: "line_discount_amount",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_percentage: {
                name: "line_discount_percentage",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_type: {
                name: "line_discount_type",
                rules: "trim|max_length[1]",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    fe_invoices: (state) => {
        return state.fe_invoices;
    },
};

// actions
const actions = {
    async fetchFeInvoices({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getFeInvoices({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageFeInvoices", response.data.page);
                }

                commit("setFeInvoices", response.data.fe_invoices);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchFeInvoice({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getFeInvoice(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedFeInvoice", response.data.fe_invoice);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printFeInvoice({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printFeInvoice(payload.id, payload.view_as);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveFeInvoice({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["invoice_id"] === "undefined" || body["invoice_id"] == null || body["invoice_id"] == "") {
                delete body["invoice_id"];
                response = await createFeInvoices({ body: body, headers: config.headers });
            } else {
                let invoice_id = body["invoice_id"];
                delete body["invoice_id"];
                response = await updateFeInvoices({ body: body, headers: config.headers }, invoice_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteFeInvoice({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteFeInvoices(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageFeInvoices(state, page) {
        state.page = page;
    },
    setFeInvoices(state, fe_invoices) {
        state.fe_invoices = fe_invoices;
    },
    setSelectedFeInvoice(state, fe_invoice) {
        state.selectedFeInvoice = fe_invoice;
    },
    resetSelectedFeInvoice(state) {
        for (const key in state.selectedFeInvoice) {
            if (key in state.rules_fe_invoices) {
                state.selectedFeInvoice[key] = state.rules_fe_invoices[key].default_value == "null" ? null : state.rules_fe_invoices[key].default_value;
            }
        }
    },
    resetFeInvoices(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.fe_invoices = [];
        state.selectedFeInvoice = {
            invoice_id: null,
            company_id: "",
            fe_invoice_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            fe_invoice_details: [],
        };
        state.fe_invoices_filter = {
            search: "",
            status_id: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
